import { useEffect, useState } from "react";
import "./PhilHealth.css";

import SelectField from "../Commons/Forms/SelectField";
import TextField from "../Commons/Forms/TextField";
import DateField from "../Commons/Forms/DateField";
import BtnSave from "../Commons/Buttons/BtnSave";
import BtnDelete from "../Commons/Buttons/BtnDelete";
import ConfirmModal from "../Modals/ConfirmModal";
import { validatePhilhealthFormData } from "../Helpers/Utilities/Validations/PhillhealthFormValidation";
import { toast } from "react-toastify";
import { updatePhilhealthRecord } from "../Helpers/API/PatientApi/PatientApi";
import { PhoneInput } from "react-international-phone";

export function AddPhilHealthForm({ patientDetails, isEditing, onCancel }) {
  const [philhealthForm, setPhilhealthForm] = useState({
    patient_type: "dependent",
    member_pin: "",
    dependent_pin: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    extension_name: "",
    birthdate: "",
    mobile_number: "",
    enlistment_date: "",
    enlistment_status: "active",
    package_type: "Konsulta Package",
    atc: "NONE",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState({
    patient_type: false,
    member_pin: false,
    dependent_pin: false,
    first_name: false,
    middle_name: false,
    last_name: false,
    extension_name: false,
    birthdate: false,
    mobile_number: false,
    enlistment_date: false,
    enlistment_status: false,
    package_type: false,
    atc: false,
  });
  const [showPrompt, setShowPrompt] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setPhilhealthForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Value onchange for patient type toggle
  const handleValueChange = (name, value) => {
    if (philhealthForm.patient_type === "member") {
      philhealthForm[name] = value;
      return patientDetails[name] || value;
    }
  };

  const handleAddPhoneChange = (value, name) => {
    if (name === "mobile_number") {
      setPhilhealthForm((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    } else {
      setPhilhealthForm((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  // Submit button validation checks
  const memberValidationCheck =
    Object.values(philhealthForm.patient_type || "").every(
      (value) => value === ""
    ) ||
    Object.values(philhealthForm.member_pin || "").every(
      (value) => value === ""
    ) ||
    Object.values(philhealthForm.first_name || "").every(
      (value) => value === ""
    ) ||
    Object.values(philhealthForm.last_name || "").every(
      (value) => value === ""
    ) ||
    Object.values(philhealthForm.birthdate || "").every(
      (value) => value === ""
    ) ||
    Object.values(philhealthForm.enlistment_date || "").every(
      (value) => value === ""
    ) ||
    Object.values(philhealthForm.enlistment_status || "").every(
      (value) => value === ""
    ) ||
    Object.values(philhealthForm.package_type || "").every(
      (value) => value === ""
    ) ||
    Object.values(philhealthForm.atc || "").every((value) => value === "");

  const dependentValidationCheck =
    Object.values(philhealthForm.patient_type || "").every(
      (value) => value === ""
    ) ||
    Object.values(philhealthForm.member_pin || "").every(
      (value) => value === ""
    ) ||
    Object.values(philhealthForm.dependent_pin || "").every(
      (value) => value === ""
    ) ||
    Object.values(philhealthForm.first_name || "").every(
      (value) => value === ""
    ) ||
    Object.values(philhealthForm.last_name || "").every(
      (value) => value === ""
    ) ||
    Object.values(philhealthForm.birthdate || "").every(
      (value) => value === ""
    ) ||
    Object.values(philhealthForm.enlistment_date || "").every(
      (value) => value === ""
    ) ||
    Object.values(philhealthForm.enlistment_status || "").every(
      (value) => value === ""
    ) ||
    Object.values(philhealthForm.package_type || "").every(
      (value) => value === ""
    ) ||
    Object.values(philhealthForm.atc || "").every((value) => value === "");

  // Submit form handler
  const handleSubmit = async () => {
    setIsLoading(true);

    if (
      validatePhilhealthFormData(philhealthForm, setIsError) &&
      !isSubmitted
    ) {
      // console.log("hereeee", philhealthForm);
      const response = await updatePhilhealthRecord(
        philhealthForm,
        patientDetails
      );

      if (response && response.status !== 200) {
        toast.error(response.response.data.messages.error_messages);
      } else {
        setIsSubmitted(true);
        toast.success("PhilHealth form submitted successfully!");
        window.location.reload();
      }
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (isEditing) {
      setPhilhealthForm({
        patient_type: patientDetails.phic_membership_type,
        member_pin: patientDetails.phic_pin,
        dependent_pin: patientDetails.phic_dependent_pin,
        first_name: patientDetails.phic_first_name,
        middle_name: patientDetails.phic_middle_name,
        last_name: patientDetails.phic_last_name,
        extension_name: patientDetails.phic_extension_name,
        birthdate: patientDetails.phic_birthdate,
        mobile_number: patientDetails.phic_contact_no,
        enlistment_date: patientDetails.phic_enlistment_date,
        enlistment_status: patientDetails.phic_enlistment_status,
        package_type: patientDetails.phic_package_type,
        atc: patientDetails.phic_atc,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="form-container">
      <h5 className="font-bold mb-4">
        {isEditing ? "EDIT PHILHEALTH FORM" : "ADD PHILHEALTH FORM"}
      </h5>
      <SelectField
        required
        formLabel={`Patient Type`}
        name="patient_type"
        value={philhealthForm.patient_type}
        size={`sm`}
        placeholder={"Select patient type"}
        options={[
          { value: "member", label: "Patient is a PhilHealth member" },
          {
            value: "dependent",
            label: "Patient is a dependent of a PhilHealth member",
          },
        ]}
        onChange={handleChange}
        isError={isError.patient_type}
        errorMessage="Patient type is required."
        disabled={isLoading}
      />
      <div className="two-input-row mt-3">
        <div>
          <TextField
            required
            id="member_pin"
            name="member_pin"
            formLabel={`Member PhilHealth Identification Number (PIN)`}
            size={`sm`}
            value={philhealthForm.member_pin}
            onChange={handleChange}
            isError={isError.member_pin}
            errorMessage="Member PIN is required."
            disabled={isLoading}
            maxLength={12}
          />
        </div>
        {philhealthForm.patient_type === "dependent" && (
          <div>
            <TextField
              required={
                philhealthForm.patient_type === "dependent" ? true : false
              }
              id="dependent_pin"
              name="dependent_pin"
              formLabel={`Dependent PhilHealth Identification Number (PIN)`}
              size={`sm`}
              onChange={handleChange}
              isError={isError.dependent_pin}
              errorMessage="Dependent PIN is required."
              disabled={isLoading}
              maxLength={12}
            />
          </div>
        )}
      </div>
      <div className="name-row">
        <div>
          <TextField
            required
            id="first_name"
            name="first_name"
            formLabel={`First name`}
            size={`sm`}
            value={
              philhealthForm.patient_type === "member"
                ? handleValueChange("first_name", patientDetails.first_name)
                : philhealthForm.first_name
            }
            onChange={handleChange}
            isError={isError.first_name}
            errorMessage="First name is required."
            disabled={philhealthForm.patient_type === "member" || isLoading}
          />
        </div>
        <div>
          <TextField
            id="middle_name"
            name="middle_name"
            formLabel={`Middle name`}
            size={`sm`}
            value={
              philhealthForm.patient_type === "member"
                ? handleValueChange("middle_name", patientDetails.middle_name)
                : philhealthForm.middle_name
            }
            isError={isError.middle_name}
            errorMessage="Middle name is required."
            disabled={philhealthForm.patient_type === "member" || isLoading}
          />
        </div>
        <div>
          <TextField
            required
            id="last_name"
            name="last_name"
            formLabel={`Last name`}
            size={`sm`}
            value={
              philhealthForm.patient_type === "member"
                ? handleValueChange("last_name", patientDetails.last_name)
                : philhealthForm.last_name
            }
            onChange={handleChange}
            isError={isError.last_name}
            errorMessage="Last name is required."
            disabled={philhealthForm.patient_type === "member" || isLoading}
          />
        </div>
        <div>
          <TextField
            id="extension_name"
            name="extension_name"
            formLabel={`Extension name`}
            size={`sm`}
            value={
              philhealthForm.patient_type === "member"
                ? handleValueChange("suffix", patientDetails.suffix)
                : philhealthForm.extension_name
            }
            isError={isError.extension_name}
            disabled={philhealthForm.patient_type === "member" || isLoading}
          />
        </div>
      </div>
      <div className="two-input-row">
        <div>
          <DateField
            required
            id="birthdate"
            name="birthdate"
            formLabel={`Birth date of primary member`}
            size={`sm`}
            value={
              philhealthForm.patient_type === "member"
                ? handleValueChange("birthdate", patientDetails.birthdate)
                : philhealthForm.birthdate
            }
            onChange={handleChange}
            isError={isError.birthdate}
            errorMessage="Birth date of primary member is required."
            disabled={philhealthForm.patient_type === "member" || isLoading}
          />
        </div>
        <div>
          {/* <TextField
            required
            id="mobile_number"
            name="mobile_number"
            formLabel={`Mobile number`}
            size={`sm`}
            value={
              philhealthForm.patient_type === "member"
                ? handleValueChange("mobile_number", patientDetails.contact_no)
                : philhealthForm.mobile_number
            }
            onChange={handleChange}
            isError={isError.mobile_number}
            errorMessage="Mobile number is required."
            disabled={isLoading}
          /> */}
          <span className="align-left">
            Mobile Number <label className="red"> *</label>
          </span>
          <PhoneInput
            id="mobile_number"
            name="mobile_number"
            defaultCountry="ph"
            value={
              philhealthForm.patient_type === "member"
                ? handleValueChange("mobile_number", patientDetails.contact_no)
                : philhealthForm.mobile_number
            }
            onChange={(e) => handleAddPhoneChange(e, "mobile_number")}
            // disabled={philhealthForm.patient_type === "member" || isLoading}
            style={{
              width: "100%",
              height: "32px",
            }}
            inputStyle={{
              width: "100%",
              height: "32px",
              border: "1px solid #d9d9d9",
            }}
            countrySelectorStyleProps={{
              style: {
                height: "32px",
              },
              buttonStyle: {
                height: "32px",
                padding: "0 8px",
              },
            }}
          />
        </div>
      </div>
      <div className="enlistment-row">
        <div>
          <DateField
            required
            id="enlistment_date"
            name="enlistment_date"
            formLabel={`Enlistment date`}
            size={`sm`}
            value={philhealthForm.enlistment_date}
            onChange={handleChange}
            isError={isError.enlistment_date}
            errorMessage="Enlistment date is required."
            disabled={isLoading}
          />
        </div>
        <div>
          <SelectField
            required
            formLabel={`Enlistment status`}
            name="enlistment_status"
            value={philhealthForm.enlistment_status}
            size={`sm`}
            placeholder={"Select enlistment status"}
            options={[
              { value: "active", label: "Active" },
              { value: "cancelled", label: "Cancelled" },
              { value: "transferred", label: "Transferred" },
            ]}
            onChange={handleChange}
            isError={isError.enlistment_status}
            errorMessage="Enlistment status is required."
            disabled={isLoading}
          />
        </div>
        <div>
          <SelectField
            required
            formLabel={`Package type`}
            name="package_type"
            value={philhealthForm.package_type}
            size={`sm`}
            placeholder={"Select package type"}
            options={[
              { value: "Konsulta Package", label: "KONSULTA Package" },
              { value: "PCB1", label: "PCB1" },
              { value: "Expanded PCB", label: "Expanded PCB" },
            ]}
            onChange={handleChange}
            isError={isError.package_type}
            errorMessage="Enlistment status is required."
            disabled={isLoading}
          />
        </div>
      </div>
      <div className="one-input-row">
        <div>
          <TextField
            required
            id="atc"
            name="atc"
            formLabel={`Authorization Transaction Code (ATC)`}
            size={`sm`}
            value={philhealthForm?.atc}
            onChange={handleChange}
            isError={isError.atc}
            errorMessage="Authorization Transaction Code (ATC) is required."
            disabled={isLoading}
          />
        </div>
      </div>
      <div className="row justify-content-end mt-5 mb-3">
        {isEditing && (
          <>
            <div className="col-2">
              <BtnDelete
                label={"Cancel"}
                size={"sm"}
                onClick={() => {
                  if (isEditing && typeof onCancel === "function") {
                    onCancel();
                  }
                }}
              />
            </div>
          </>
        )}
        <div className="col-2">
          <BtnSave
            label={"Submit"}
            size={"sm"}
            onClick={() => setShowPrompt(true)}
            isClicked={isLoading}
            disabled={
              !philhealthForm || philhealthForm.patient_type === "member"
                ? memberValidationCheck
                : dependentValidationCheck
            }
          />
        </div>
      </div>
      <ConfirmModal
        show={showPrompt}
        onHide={() => setShowPrompt(false)}
        onConfirm={() => handleSubmit()}
        message={<ModalContent philhealthForm={philhealthForm} />}
      />
    </div>
  );
}

function ModalContent({ philhealthForm }) {
  const { patient_type, member_pin, dependent_pin, first_name, last_name } =
    philhealthForm;

  return (
    <>
      Proceed form submission?
      <div className="row">
        <strong>PIN:</strong>
        <p>{member_pin}</p>
      </div>
      {patient_type === "dependent" && (
        <div className="row">
          <strong>Dependent PIN:</strong>
          <p>{dependent_pin}</p>
        </div>
      )}
      <div className="row">
        <strong>Member name:</strong>
        <p>{`${first_name} ${last_name}`}</p>
      </div>
    </>
  );
}
